<p-fileupload
    #fileUpload
    mode="basic"
    name="files"
    [id]="valueAccessor.inputId"
    [accept]="acceptedFiles"
    [auto]="true"
    [customUpload]="true"
    (uploadHandler)="onUpload($event)"
    [multiple]="true"
    chooseIcon="pi pi-plus"/>

<ul *ngIf="fileFromServer.length" class="file-list">
    <li *ngFor="let file of fileFromServer">
        <div class="file-item">
        <div class="file-info">
            <div class="file-name">{{ file.original_name }}.{{ file.ext }}</div>
        </div>
        </div>
    
        <div class="file-actions">
        <button pButton 
            type="button" 
            class="p-button-secondary p-button-rounded p-button-outlined" 
            icon="pi pi-download" 
            (click)="downloadFile(file)">
        </button>
        <button pButton 
            type="button" 
            class="p-button-danger p-button-rounded p-button-outlined" 
            icon="pi pi-trash" 
            (click)="removeFile(file)">
        </button>
        </div>
    </li>
</ul>